import React from "react";
import { graphql, HeadProps, PageProps } from "gatsby";
import { PageQuery } from "types/graphql-types";
import { PageContext } from "types/pageContext";
import SanityBuilderToComponents from "components/PageBuilder";
import { isPresent } from "src/utils/checks";
import GatsbyHeadOpenGraph from "components/SEO/GatsbyHeadOpenGraph";
import { fallbackOpenGraphFromPageBuilderSections } from "components/SEO/utils";

type PageQueryProps = PageQuery & {
  page: NonNullable<PageQuery["page"]>;
};

const PageTemplate: React.FC<
  React.PropsWithChildren<PageProps<PageQueryProps, PageContext>>
> = ({ data }) => {
  const page = data.page;
  const sections = page.sections?.filter(isPresent) || [];

  return (
    <React.Fragment>
      {sections?.length > 0 && (
        <SanityBuilderToComponents sections={sections} />
      )}
    </React.Fragment>
  );
};

export const Head = (props: HeadProps<PageQueryProps, PageContext>) => {
  const { data, pageContext } = props;
  const { fallbackSeoTitle, fallbackSeoImage } =
    fallbackOpenGraphFromPageBuilderSections(data.page.sections);

  return (
    <GatsbyHeadOpenGraph
      path={props.location.pathname}
      alternateLinks={pageContext.alternateLinks}
      languageCode={pageContext.languageCode}
      openGraph={data.page?.metadata?.openGraph}
      altTitle={fallbackSeoTitle}
      altImage={fallbackSeoImage}
      excludeFromSitemap={data.page?.metadata?.excludeFromSitemap}
    ></GatsbyHeadOpenGraph>
  );
};

export const query = graphql`
  query Page($id: String) {
    page: sanityPage(id: { eq: $id }) {
      metadata {
        excludeFromSitemap
        openGraph {
          ...OpenGraphMetaTags
        }
      }

      title {
        localized
      }
      sections {
        ...PageBuilderSections
        ... on SanitySharedSectionRef {
          ...PageBuilderSharedSectionRef
        }
      }
    }
  }
`;

export default PageTemplate;
